import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="swipe"
// Dispatches events: swipe:left, swipe:right, swipe:up, swipe:down
export default class extends Controller {
  static values = {
    minX: { type: Number, default: 20 },
    maxX: { type: Number, default: 60 },
    minY: { type: Number, default: 30 },
    maxY: { type: Number, default: 30 }
  }

  connect() {
    this.startX = 0
    this.startY = 0
    this.endX = 0
    this.endY = 0
    
    this.passiveSupported = this.checkPassiveSupport()

    // We need passive: false to be able to preventDefault() and stop browser navigation gestures
    const options = this.passiveSupported ? { passive: false } : false
    
    this.boundHandleTouchStart = this.handleTouchStart.bind(this)
    this.boundHandleTouchMove = this.handleTouchMove.bind(this)
    this.boundHandleTouchEnd = this.handleTouchEnd.bind(this)

    this.element.addEventListener('touchstart', this.boundHandleTouchStart, options)
    this.element.addEventListener('touchmove', this.boundHandleTouchMove, options)
    this.element.addEventListener('touchend', this.boundHandleTouchEnd)
  }

  disconnect() {
    const options = this.passiveSupported ? { passive: false } : false
    this.element.removeEventListener('touchstart', this.boundHandleTouchStart, options)
    this.element.removeEventListener('touchmove', this.boundHandleTouchMove, options)
    this.element.removeEventListener('touchend', this.boundHandleTouchEnd)
  }

  handleTouchStart(event) {
    const touch = event.touches[0]
    this.startX = touch.screenX
    this.startY = touch.screenY
  }

  handleTouchMove(event) {
    const touch = event.touches[0]
    this.endX = touch.screenX
    this.endY = touch.screenY

    const diffX = this.endX - this.startX
    const diffY = this.endY - this.startY
    
    // If movement is primarily horizontal and exceeds a small threshold, prevent default
    // This stops the browser from navigating back/forward or scrolling vertically
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
      if (event.cancelable) {
        event.preventDefault()
      }
    }
  }

  handleTouchEnd(event) {
    const diffX = this.endX - this.startX
    const diffY = this.endY - this.startY
    const absDiffX = Math.abs(diffX)
    const absDiffY = Math.abs(diffY)

    let direction = null

    // Horizontal move
    if (absDiffX > this.minXValue && absDiffY < this.maxYValue) {
      direction = (diffX > 0) ? 'right' : 'left'
    } 
    // Vertical move
    else if (absDiffY > this.minYValue && absDiffX < this.maxXValue) {
      direction = (diffY > 0) ? 'down' : 'up'
    }

    if (direction) {
      this.dispatch(direction, { detail: { originalEvent: event } })
    }
  }

  checkPassiveSupport() {
    let supported = false
    try {
      const options = {
        get passive() {
          supported = true
          return false
        }
      }
      window.addEventListener("test", null, options)
      window.removeEventListener("test", null, options)
    } catch (err) {
      supported = false
    }
    return supported
  }
}
